export default __webpack_public_path__ + "static/media/document-icon.0fb03c47.svg";